module.exports = __webpack_public_path__ + "static/media/a-1.26dea2ee.png";